

export default function ViewSectionName(props) {

  return (
    <>
    <div className="pb-3"></div>
    <h2 className="caption-sm text-muted">{props.data}</h2>
    <div className="mb-3"></div>
    </>
  )
}